
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sdcddnsmkbluioijdnbr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNkY2RkbnNta2JsdWlvaWpkbmJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1MTc3ODMsImV4cCI6MjA4MTA5Mzc4M30.CYdyH2IKgoSV4nT7DjaYeZqipXLFUvji-JklTCZFb2s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
